export default {
  works: [
    {
      id: 117236,
      role: 'Senior Front-end Developer',
      company: 'Arab African International Bank',
      from: 'Nov 2022',
      to: 'Present',
      img: require('../assets/images/companies/aaib.png'),
      desc: "I'm responsible for developing and leading the mobile development team who's responsible for the main mobile application which contains all main bank services.",
    },
    {
      id: 1,
      role: 'Senior Front-end Developer',
      company: 'Orange Labs',
      from: 'Dec 2021',
      to: 'Nov 2022',
      img: require('../assets/images/companies/orange.png'),
      desc: " I'm responsible for creating a Web and a Cross-Platform Mobile Application using Angular and Ionic Javascript Frameworks.",
    },
    {
      id: 2,
      role: 'React Native Developer',
      company: 'Pentavalue',
      from: 'Feb 2020',
      to: 'Dec 2021',
      img: require('../assets/images/companies/penta.png'),
      desc: " I'm responsible for creating Cross-Platform Mobile Application using React Native Library.",
    },
    {
      id: 3,
      role: 'FullStack Javascript Developer',
      company: "Bond'n Beyond",
      from: 'Jun 2019',
      to: 'Dec 2019',
      img: require('../assets/images/companies/bond.png'),
      desc: " I'm responsible for creating a company Product ( Web & Mobile & Backend ) Using React-JS For Web Dasboard , React Native For Mobile Application and 'Node - Express - MongoDB ' For Backend side  ",
    },

    {
      id: 3,
      role: 'Pre-Sales Engineer',
      company: 'JRM For Communication',
      from: 'Jun 2017',
      to: 'Sep 2018',
      img: require('../assets/images/companies/jrm.jpeg'),
      desc: " I'm responsible for Desing and Setup a best fit Network System for any organization ",
    },
  ],
  educations: [
    {
      id: 11,
      role: '9-Month Diploma Open Source Application Track',
      company: 'Information Technology Institute (ITI) Intake 39',
      from: 'Sep 2018',
      to: 'Jun 2019',
      img: require('../assets/images/companies/iti.webp'),
      desc: " It's a well-known diploma in egypt that focuses on all open-source Technologies in software industries like MEARN, Python, PHP, Linux,...",
    },
    {
      id: 12,
      role: 'Bachelor Degree of Communication & Computer Systems Engineering',
      company: 'Shoubra Faculty of Engineering ( Benha University )',
      from: '2012',
      to: '2017',
      img: require('../assets/images/companies/shoubra.jpeg'),
      desc: ' Bachelor Degree of Communication & Computer Systems Engineering where studing most of Network and Computer Sytems in Academic way',
    },
  ],

  projects: [
    {
      id: 6567,
      name: 'Motanafeson',
      desc: 'Motannanonoon is a fun and educational Islamic quiz app that challenges you and expands your knowledge of Islam.',
      logo: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FMotanafeson%2Flogo.png?alt=media&token=02f56ffc-f57d-437b-b35c-a5e968ac47a6',
      cover:
        'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FMotanafeson%2FScreenshot%202023-07-03%20at%204.37.59%20PM.png?alt=media&token=e2b644ae-f140-4a1d-9c00-5bb0076ce55e',
      cardCover:
        'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FMotanafeson%2FMutanefson.png?alt=media&token=73c81054-d2c8-41ae-b14f-56346f857999',
      type: 'mobile',
      playURL:
        'https://play.google.com/store/apps/details?id=com.scorpion.mutanafeson',
      features: [
        {
          id: 1,
          title: 'Diverse Quizzes',
          desc: "Explore a wide range of quizzes covering various aspects of Islam, including Quranic knowledge, Prophet's biography, Islamic history, and more. Test your knowledge and learn new facts along the way",
          img: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FMotanafeson%2FScreenshot_1683976687.png?alt=media&token=34774848-9c09-459a-9fa0-38c65842f7ad',
        },
        {
          id: 2,
          title: 'Competitive Ranking System',
          desc: 'Compete with other users and climb the ranks to become a top player. Earn points for each correct answer and see your progress on the leaderboard. Aim for the top to earn exclusive rewards!',
          img: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FMotanafeson%2FScreenshot_1688402318.png?alt=media&token=5ea3515e-d89d-4e51-b6d7-61c941b0eca8',
        },
        {
          id: 3,
          title: 'Personalized Profiles',
          desc: 'Customize your profile with a unique avatar, display name, and bio. Showcase your achievements, badges, and earned virtual rewards. Let others know your expertise in Islamic knowledge." ',
          img: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FMotanafeson%2FScreenshot_1688402349.png?alt=media&token=6f0a8758-1e10-4c2d-b84f-ed0e116f97a0',
        },
      ],
      otherFeatures: [
        'Daily Challenges for continuous learning and earning bonus points',
        'Social Interaction through discussion forums and social media sharing',
        'Virtual Rewards in the form of virtual currency, badges, and patches',
        'Push Notifications to stay updated on new quizzes and events',
        'Change Application Language (Arabic and English)',
        'Light and Dark Themes',
      ],
      demoURL: 'https://www.youtube.com/embed/JC4_at7ckvQ',
    },
    {
      id: 1,
      name: 'Booky',
      desc: 'Mobile Application for Read latest books and novels & Publish yours',
      logo: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FBooky%2Flogo.png?alt=media&token=39339dff-6bbb-4055-9090-0d3efd41c5a2',
      cover:
        'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FBooky%2Fcover.png?alt=media&token=913406cf-71fd-45f3-aebc-b2c9d45a37aa',
      cardCover:
        'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FBooky%2FBooky%20Cover.png?alt=media&token=ee015fcb-30cf-48c3-91ae-6dbc563cb3b5',
      type: 'mobile',
      playURL:
        'https://play.google.com/store/apps/details?id=com.scorpion.booky',
      features: [
        {
          id: 1,
          title: 'Book Details',
          desc: "Here you can find all book details like ' Title , Cover , Rate , Review , Descritption and Author ' along with reading it online if PDF Version is available available also you can make a small book club discussion using book comments. ",
          img: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FBooky%2F2.jpg?alt=media&token=79342f13-fd2e-4f0e-8b93-c736a0447025',
        },
        {
          id: 2,
          title: 'Library',
          desc: 'Virtual Library where you can find most popular books and filter them using multiable genres or with search box.',
          img: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FBooky%2F1.jpg?alt=media&token=09b481bb-617b-404e-a7bb-c3b49e216188',
        },
        {
          id: 3,
          title: 'Author Profile',
          desc: 'Also You can find all author public data like " Name , Biograpghy and his books " ',
          img: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FBooky%2F3.jpg?alt=media&token=d6a05533-39e9-4753-86f6-75ff9d3c86ec',
        },
      ],
      otherFeatures: [
        'Show & Discuss Latest Articles In Differient Feilds',
        'Write & Publish Your Own Article',
        'Make Your Social Network',
        'Create , Update and Delete Your Custom Book Shelfs',
        'Change Application Language (Arabic and English)',
        'Light and Dark Themes',
        'Subscribe to Book PDF Version Release',
        'Order a Specific Book from Booky Team',
      ],
      demoURL: 'https://www.youtube.com/embed/ha3FZPxmBvI',
    },
    {
      id: 2,
      name: 'Zikra',
      desc: 'Zikra is an Islamic application full of features that every Muslim needs in his daily life, where he can listen and read the entire Noble Qur’an for a selection of the most prominent sheikhs with the feature of the call to prayer at every prayerIn addition to hundreds of daily supplications and several interpretations of the Holy Qur’an, such as the easy interpretation, the interpretation of Al-Jalalain, Ibn Kathir and others',
      logo: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FZikra%2Flogo.png?alt=media&token=29ee3649-51d8-47b5-9a23-1c8bd4e39576',
      cover:
        'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FZikra%2Fcover.png?alt=media&token=c4b1abdd-a43d-4fa3-a064-5bc170c351c0',
      cardCover:
        'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FZikra%2Fzykra.png?alt=media&token=78d7d82a-ec24-4182-ad3f-0cc9d594cb8e',
      type: 'mobile',
      playURL:
        'https://play.google.com/store/apps/details?id=com.taqanah.zekra',
      iosStore:
        'https://apps.apple.com/us/app/%D8%B0%D9%83%D8%B1%D9%89/id1604248956',
      features: [
        {
          id: 1,
          title: 'Prayer Times',
          desc: 'Here you can find Times for today prayers and activate and de-activate prayer azan for a specific prayer',
          img: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FZikra%2F2.webp?alt=media&token=e19eda4b-f3a0-446d-88bb-b2426dd046e3',
        },
        {
          id: 2,
          title: 'Tsabeeh',
          desc: 'Azkar Countre for dialy azkar like astighfar , hamd and tawheed and other azkar ',
          img: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FZikra%2F3.webp?alt=media&token=1fe6d025-ecf5-490d-9572-1c152b419eae',
        },
      ],
      otherFeatures: [
        'Qibla Direction',
        "Choose you favourite moa'zen from group of top sheikh in the middle east ",
        'Listen Quran with the best sheiks in arab world',
        'Read Multible Quran Tafseers',
        'Read Sunna and Hadeeth',
      ],
      // demoURL:"https://www.youtube.com/embed/ha3FZPxmBvI"
    },
    {
      id: 4,
      name: 'Feeding Freenzy Game',
      desc: 'An implementation for a well-known game called feeding frenzy using javascript.',
      logo: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FFeed%2Flogo.png?alt=media&token=1e62b329-9613-4c4a-931d-437c77ace0fa',
      cover:
        'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FFeed%2Fcover.png?alt=media&token=308185af-4e05-47ad-8c47-4c742eea54f7',
      type: 'web',
      webURL: 'https://feedingfreenzy.netlify.app',
      features: [
        {
          id: 1,
          title: 'Persona',
          desc: 'Enter your name before playing to compute with other players',
          img: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FFeed%2F1.png?alt=media&token=cf054e40-4a36-4a5e-8c1d-9fea4d54c5d7',
        },
        {
          id: 2,
          title: 'Multi Fishes',
          desc: 'There are two different fishes to choose your preferred one',
          img: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FFeed%2F2.png?alt=media&token=6ab9bc13-2ee4-4e29-a8ee-96104927c9e2',
        },
        {
          id: 3,
          title: 'Multi Levels',
          desc: "There are three levels of difficulty what changes enemies' speed",
          img: 'https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Projects%2FFeed%2F4.png?alt=media&token=dc19ceec-a388-4717-abad-5ec37ce7ce27',
        },
      ],
      otherFeatures: [
        'Ocean sound in the background',
        'Pause and resume game',
        'High Score',
        'Score badges',
      ],
      // demoURL:"https://www.youtube.com/embed/ha3FZPxmBvI"
    },
  ],
};
